import React, { PureComponent } from "react";
import { Draggable } from "react-beautiful-dnd";
import NoteTagList from "../theme/buttons/NoteTag";
import { connect } from "react-redux";
import { setSessionVar } from "../../store/actions";

class DraggableSiteCard extends PureComponent {
  handleDeleteClick = (e) => {
    e.stopPropagation();
    const { onDeleteClick, data } = this.props;
    if (!onDeleteClick) return;

    const name = data.name ? `"${data.name}"` : "this site";
    if (
      window.confirm(`Are you sure you want to remove ${name} from this seat?`)
    ) {
      onDeleteClick(e);
    }
  };

  render() {
    let draggableId = this.props.draggableId || this.props.name;
    let data = this.props.data || {};
    return (
      <Draggable draggableId={draggableId} index={this.props.index}>
        {(provided, snapshot) => (
          <div
            className={`side-menu-draggable ${
              this.props.focused ? "focused" : ""
            }`}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            onClick={this.props.onClick}
            onMouseEnter={this.props.onMouseEnter}
            onMouseLeave={this.props.onMouseLeave}
          >
            {this.props.showDelete ? (
              <i
                className="remove-seat-icon far fa-times-circle fa-pull-right"
                style={{ cursor: "default" }}
                onClick={this.handleDeleteClick}
              ></i>
            ) : null}
            <div
              className="list-obj-inner-wrapper"
              style={{ borderLeftColor: this.props.color }}
              id={this.props.id}
            >
              <div className="obj-title">{data.name}</div>
              <div className="obj-data" style={{ marginTop: "9px" }}>
                {data.addressline1} {data.addressline2} <br />
                {data.city}, {data.statecode} {data.zip5}
              </div>
              <div
                className={"clickable-children"}
                onClick={() => this.props.setSiteModalSite(data)}
              >
                <NoteTagList notes={data.notes} />
              </div>
            </div>
          </div>
        )}
      </Draggable>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setSiteModalSite: (site) =>
    dispatch(setSessionVar("siteNoteModalSite", site)),
});

export default connect(null, mapDispatchToProps)(DraggableSiteCard);
